/**
 * モバイルナビゲーションの開閉を制御する
 *
 * 処理の流れ:
 * 1. ハンバーガーメニューボタンとサイドナビの要素を取得する
 * 2. サイドナビの内容をコピーしたオーバーレイ（全画面メニュー）をDOMに追加する
 * 3. ボタンのクリックでオーバーレイの開閉をトグルする
 * 4. オーバーレイ外クリック・ESCキー・リサイズ・メニュー内リンククリックで閉じる
 */
export function initMobileMenu() {
  'use strict';

  const body = document.body;
  const menuButton = document.getElementById('hamburgerMenu');
  const sideNav = document.getElementById('side-nav');

  // 必要な要素が存在しない場合は処理を中断する
  if (!body || !menuButton || !sideNav) {
    return;
  }

  // サイドナビ内のナビリンク一覧とCTAボタン群を取得する
  const nav = sideNav.querySelector('.sideNav__nav');
  const buttons = sideNav.querySelector('.sideNav__btns');

  if (!nav) {
    return;
  }

  // -------------------------------------------------------
  // オーバーレイ（全画面モバイルメニュー）をJSで生成する
  // HTMLに直接書くとデスクトップ用のサイドナビと内容が二重管理になるため、
  // ここでサイドナビの内容をコピーして動的に生成する方式にしている
  // -------------------------------------------------------
  const overlay = document.createElement('div');
  overlay.className = 'js-mobileNavOverlay';
  overlay.id = 'engineer-mobile-nav';
  overlay.setAttribute('aria-hidden', 'true'); // 初期状態はスクリーンリーダーから隠す

  // オーバーレイの内側ラッパー（CSSアニメーション用）
  const overlayInner = document.createElement('div');
  overlayInner.className = 'js-mobileNavOverlay__inner';

  // サイドナビのリンク一覧を複製してオーバーレイに追加する
  // cloneNode(true) で子要素も含めてコピーできる
  const navClone = nav.cloneNode(true);
  overlayInner.appendChild(navClone);

  // CTAボタン群が存在すれば同様に複製して追加する
  if (buttons) {
    overlayInner.appendChild(buttons.cloneNode(true));
  }

  overlay.appendChild(overlayInner);

  // 生成したオーバーレイをbodyに追加する（position: fixed で画面全体に表示される）
  body.appendChild(overlay);

  // アクセシビリティ属性: ボタンがどの要素を操作するかをスクリーンリーダーに伝える
  menuButton.setAttribute('aria-controls', overlay.id);
  menuButton.setAttribute('aria-expanded', 'false');

  // -------------------------------------------------------
  // メニューを閉じる処理
  // -------------------------------------------------------
  const closeMenu = function() {
    body.classList.remove('is-menu-open');          // CSSアニメーションのトリガーを外す
    overlay.setAttribute('aria-hidden', 'true');    // スクリーンリーダーから非表示にする
    menuButton.setAttribute('aria-expanded', 'false');
    menuButton.setAttribute('aria-label', 'メニューを開く');
  };

  // -------------------------------------------------------
  // メニューを開く処理
  // -------------------------------------------------------
  const openMenu = function() {
    body.classList.add('is-menu-open');             // CSSアニメーションのトリガーを付与する
    overlay.setAttribute('aria-hidden', 'false');   // スクリーンリーダーに表示状態を伝える
    menuButton.setAttribute('aria-expanded', 'true');
    menuButton.setAttribute('aria-label', 'メニューを閉じる');
  };

  // -------------------------------------------------------
  // メニューの開閉をトグルする処理
  // -------------------------------------------------------
  const toggleMenu = function() {
    if (body.classList.contains('is-menu-open')) {
      closeMenu();
      return;
    }

    openMenu();
  };

  // ハンバーガーボタンをクリックしたらトグルする
  menuButton.addEventListener('click', function() {
    toggleMenu();
  });

  // オーバーレイの背景部分（メニュー外側）をクリックしたら閉じる
  overlay.addEventListener('click', function(event) {
    if (event.target === overlay) {
      closeMenu();
    }
  });

  // メニュー内のアンカーリンクをクリックしたら閉じる
  // （リンク先のセクションへスクロールするので、メニューは不要になる）
  overlay.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function() {
      closeMenu();
    });
  });

  // ESCキーを押したら閉じる（キーボード操作のアクセシビリティ対応）
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape' && body.classList.contains('is-menu-open')) {
      closeMenu();
    }
  });

  // ウィンドウ幅がデスクトップサイズ（768px以上）になったら強制的に閉じる
  // （モバイルを横にした場合などでメニューが残り続けるのを防ぐため）
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 768) {
      closeMenu();
    }
  });
}
